export interface FieldBaseTypeObject {
  id: number;
  value: "text" | "number" | "date" | "datetime" | "decimal";
  label: string;
}

export const FIELD_BASE_TYPES: Record<string, FieldBaseTypeObject> = {
  TEXT:      { id: 1, value: "text",     label: "Texte" },
  NUMBER:    { id: 2, value: "number",   label: "Nombre" },
  DATE:      { id: 3, value: "date",     label: "Date" },
  DATETIME:  { id: 4, value: "datetime", label: "Date & Heure" },
  DECIMAL:   { id: 5, value: "decimal",  label: "Décimal" },
};

export const FIELD_BASE_TYPES_LIST = Object.values(FIELD_BASE_TYPES);

export function getBaseTypeById(id: number) {
  return FIELD_BASE_TYPES_LIST.find(t => t.id === id);
}

export function getBaseTypeByValue(v: string) {
  return FIELD_BASE_TYPES_LIST.find(t => t.value === v);
}